import { Button } from '@/components/ui/Button';

import { useChromeCredentialImport } from './chrome-credential-import.query';

export const ChromeCredentialImportButton = () => {
  const importer = useChromeCredentialImport();
  return (
    <Button
      className="shrink-0"
      size="sm"
      variant="outline"
      isLoading={importer.busy}
      loadingText="Importing…"
      onClick={() => importer.mutate()}
    >
      Import from Browser
    </Button>
  );
};
